import SVGIconWrapper from "./SVGIconWrapper"

const IconTagSingleBold = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "#000000"}
        style={props.style}
        viewBox="0 0 500 500"
        iconClass={`icon--tag-single-bold ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <path d="M222.7 499h-10.2c-9.1-2-15.9-8-22.4-14.5-57-57.2-114.1-114.2-171.3-171.2C11.1 305.5 4 297.8 1 286.6v-12c2-11.5 9.6-19.5 17.6-27.4C100.9 166.9 183.1 86.5 265.3 6c4.1-4 8.6-6 14.4-6 66.5.1 133 .2 199.5-.1C489.4 0 496 3.4 500 13.1v223.7c-3 4.2-6 8.9-9.8 12.5-81.6 78.2-163.3 156.2-245 234.4-6.7 6.4-13.3 12.3-22.5 15.3zM467 33h-6.2c-57 0-114 .2-171 .1-3.7 0-6.2 1.2-8.9 3.8-81 79.3-162 158.7-243 237.9-5.3 5.2-5.3 5.3 0 10.6l175.5 175.5c1.2 1.2 2.4 2.3 3.7 3.5 1.2-1 2.1-1.8 3-2.7 81.3-77.7 162.6-155.4 243.7-233.2 1.6-1.5 2.8-4.4 2.8-6.7.1-61 .3-122 .3-183 .1-1.7.1-3.8.1-5.8z" /><path d="M389.1 55.6c30.5 0 55.5 25.2 55.4 55.7-.1 30.2-25.2 55.2-55.5 55.1-30.3 0-55.4-25-55.4-55.2 0-30.6 25-55.6 55.5-55.6zm22.2 55.5c0-12.5-9.8-22.3-22.2-22.3-12.3 0-22 9.6-22.1 21.9-.1 12.5 9.5 22.4 22 22.5 12.3.1 22.2-9.7 22.3-22.1z" />
    </SVGIconWrapper>
)

export default IconTagSingleBold